import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../api/axios';
import { Plus, Trash2, Save, Settings } from 'lucide-react';

const COLORS = ['#6b7280','#007aff','#34c759','#ff9500','#ef4444','#8b5cf6','#ec4899','#06b6d4'];

export default function AdminTaskSettings() {
  const [columns, setColumns] = useState([]);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/tasks/kanban-columns').then(r => setColumns(r.data));
  }, []);

  const addColumn = () => {
    setColumns(prev => [...prev, { id: 'new-' + Date.now(), name: '', color: '#007aff', order_index: prev.length + 1, is_default: false, isNew: true }]);
  };

  const removeColumn = (id) => {
    setColumns(prev => prev.filter(c => c.id !== id));
  };

  const saveColumns = async () => {
    // Mevcut sütunları sil ve yeniden ekle
    for (const col of columns) {
      if (col.isNew) {
        await api.post('/tasks/kanban-columns', { name: col.name, color: col.color, order_index: col.order_index });
      } else {
        await api.put('/tasks/kanban-columns/' + col.id, { name: col.name, color: col.color, order_index: col.order_index });
      }
    }
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    api.get('/tasks/kanban-columns').then(r => setColumns(r.data));
  };

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontWeight: 700, fontSize: 22, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Settings size={22} color="#007aff" /> Görev Yönetimi Ayarları
        </h2>
      </div>

      <div style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 16, padding: '24px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', maxWidth: 600 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e', marginBottom: 6 }}>Kanban Sütunları</div>
        <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 18 }}>Kanban panosundaki sütunları düzenleyin, ekleyin veya kaldırın.</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          {columns.map((col, i) => (
            <div key={col.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#f9fafb', borderRadius: 10, padding: '10px 14px' }}>
              <div style={{ display: 'flex', gap: 6 }}>
                {COLORS.map(c => (
                  <button key={c} onClick={() => setColumns(prev => prev.map(x => x.id === col.id ? {...x, color: c} : x))}
                    style={{ width: 20, height: 20, borderRadius: '50%', background: c, border: col.color === c ? '2px solid #1a1a2e' : '2px solid transparent', cursor: 'pointer' }} />
                ))}
              </div>
              <input value={col.name} onChange={e => setColumns(prev => prev.map(x => x.id === col.id ? {...x, name: e.target.value} : x))}
                placeholder="Sütun adı..."
                style={{ flex: 1, padding: '7px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, outline: 'none' }} />
              {!col.is_default && (
                <button onClick={() => removeColumn(col.id)} style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: 'none', borderRadius: 7, padding: '6px 8px', cursor: 'pointer', display: 'flex' }}>
                  <Trash2 size={13} />
                </button>
              )}
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={addColumn} style={{ background: 'rgba(0,122,255,0.08)', color: '#007aff', border: 'none', borderRadius: 10, padding: '9px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <Plus size={14} /> Sütun Ekle
          </button>
          <button onClick={saveColumns} style={{ background: saved ? '#34c759' : 'linear-gradient(135deg, #007aff, #5856d6)', color: 'white', border: 'none', borderRadius: 10, padding: '9px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
            <Save size={14} /> {saved ? 'Kaydedildi ✓' : 'Kaydet'}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
